const DEFAULT_REQUIRED_PROFILE_FIELDS = [
  "full_name",
  "phone",
  "business_name",
  "abn",
  "trade_types",
];

const GOD_MODE_EMAILS = new Set([
  "shannon@yousolar.com.au",
  "andrew@yousolar.com.au",
]);

export function getLeadTabStorageKey(leadId) {
  return leadId ? `rqp_lead_detail_tab_${leadId}` : "rqp_lead_detail_tab";
}

export function getOverviewDismissedStorageKey(businessId) {
  return businessId
    ? `rqp_overview_dismissed_${businessId}`
    : "rqp_overview_dismissed";
}

export function getPipelineViewStorageKey(businessId) {
  return businessId
    ? `rqp_pipeline_view_${businessId}`
    : "rqp_pipeline_view";
}

export function getSampleLeadDismissedStorageKey(businessId) {
  return businessId
    ? `rqp_sample_lead_dismissed_${businessId}`
    : "rqp_sample_lead_dismissed";
}

export function isGodModeEmail(email) {
  return GOD_MODE_EMAILS.has(String(email || "").trim().toLowerCase());
}

export function getProfileCompletion(profile, requiredFields = DEFAULT_REQUIRED_PROFILE_FIELDS) {
  const filled = requiredFields.filter((field) => {
    const value = profile?.[field];
    if (Array.isArray(value)) return value.length > 0;
    return String(value ?? "").trim().length > 0;
  }).length;

  return {
    filled,
    total: requiredFields.length,
    percent: requiredFields.length
      ? Math.round((filled / requiredFields.length) * 100)
      : 100,
    complete: filled === requiredFields.length,
  };
}

export function shouldShowSetupOverview({ profile, requests = [], overviewDismissed = false }) {
  if (overviewDismissed) return false;
  const completion = getProfileCompletion(profile);
  return !completion.complete || requests.length === 0;
}

export function normalizeLeadDetailTab(tab) {
  const mapped = {
    details: "overview",
    media: "overview",
  };
  const next = mapped[tab] || tab || "quote";
  const allowed = new Set(["overview", "quote", "messages", "notes", "invoice", "activity"]);
  return allowed.has(next) ? next : "quote";
}

export function normalizePipelineViewMode(mode) {
  const mapped = {
    kanban: "board",
  };
  const next = mapped[mode] || mode || "board";
  return next === "list" ? "list" : "board";
}

export function shouldHoldTradieDashboardForSubscription({
  isTradie,
  businessId,
  subscription,
}) {
  return !!(isTradie && businessId && subscription?.loading);
}
